/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Native_Desc6Inputs */

const en_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin/Swift modules exactly where platform performance or APIs demand them, camera, sensors, biometrics, bluetooth.`)
};

const ar_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وحدات Kotlin/Swift تمامًا حيث يتطلب أداء المنصة أو واجهاتها، الكاميرا والحساسات والبصمة والبلوتوث.`)
};

const bn_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin/Swift মডিউল শুধু যেখানে প্ল্যাটফর্ম পারফরম্যান্স বা API দাবি করে, ক্যামেরা, সেন্সর, বায়োমেট্রিক্স, ব্লুটুথ।`)
};

const de_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin/Swift-Module genau dort, wo Plattformleistung oder APIs sie erfordern, Kamera, Sensoren, Biometrie, Bluetooth.`)
};

const es_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módulos Kotlin/Swift exactamente donde el rendimiento de la plataforma o las API los exigen: cámara, sensores, biometría, bluetooth.`)
};

const fr_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modules Kotlin/Swift exactement là où les performances de la plateforme ou les API les exigent, caméra, capteurs, biométrie, Bluetooth.`)
};

const pt_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Módulos Kotlin/Swift exatamente onde o desempenho da plataforma ou APIs exigem, câmera, sensores, biometria, bluetooth.`)
};

const zh_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin/Swift 模块正是平台性能或 API 所需要的，相机、传感器、生物识别、蓝牙。`)
};

const tr_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kotlin/Swift modülleri tam olarak platform performansının veya API'lerin gerektirdiği yerde, kamera, sensörler, biyometri, bluetooth.`)
};

const ru_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Модули Kotlin/Swift именно там, где этого требует производительность платформы или API: камера, датчики, биометрия, Bluetooth.`)
};

const pl_svc_mobile_app_development_native_desc6 = /** @type {(inputs: Svc_Mobile_App_Development_Native_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moduły Kotlin/Swift dokładnie tam, gdzie wymaga tego wydajność platformy lub interfejsy API, kamera, czujniki, biometria, bluetooth.`)
};

/**
* | output |
* | --- |
* | "Kotlin/Swift modules exactly where platform performance or APIs demand them, camera, sensors, biometrics, bluetooth." |
*
* @param {Svc_Mobile_App_Development_Native_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_native_desc6 = /** @type {((inputs?: Svc_Mobile_App_Development_Native_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Native_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "de") return de_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "es") return es_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_native_desc6(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_native_desc6(inputs)
	return en_svc_mobile_app_development_native_desc6(inputs)
});
export { svc_mobile_app_development_native_desc6 as "svc_mobile-app-development_NATIVE_desc" }